// Fires the Meta Pixel "CompleteRegistration" standard event. Guards against
// window.fbq not being defined (e.g. ad blockers, script load failure) so a
// missing Pixel never breaks the submission flow.
export const trackCompleteRegistration = () => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "CompleteRegistration");
    }
  } catch (_) {
    // no-op - tracking should never break submission flow
  }
};
